import React from 'react';
import { formatDecimalAsPercentage } from 'ns_libs/formatter';
import { Col, Row } from 'reactstrap';
import { IInvestmentMetricsData } from '../../../types';

export const InvestmentMetrics: React.FC<{ data: IInvestmentMetricsData }> = ({ data }) => (
    data && (
        <div className="text-white text-right">
            <Row>
                <Col xs="6">ROI:</Col>
                <Col xs="6" className="text-truncate">
                    {data.roi !== null && data.roi !== undefined ? formatDecimalAsPercentage(data.roi, 2) : '-'}
                </Col>
            </Row>
            <Row>
                <Col xs="6">EMx:</Col>
                <Col xs="6" className="text-truncate">
                    {data.emx !== null && data.emx !== undefined ? `${data.emx}X` : '-'}
                </Col>
            </Row>
            <Row>
                <Col xs="6">IRR:</Col>
                <Col xs="6" className="text-truncate">
                    {data.irr !== null && data.irr !== undefined ? formatDecimalAsPercentage(data.irr, 2) : '-'}
                </Col>
            </Row>
        </div>
    )
);

export default InvestmentMetrics;
